import React, { useEffect, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "../ag-table.css";
import SchemeRowDef from "./SchemeRowDef";
import { schemeColDef } from "./schemeColDef";
import { useModalContext } from "../ModalContext";
import { getUser } from "../helpers";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  Grid,
  MenuItem,
  Modal,
  TextField,
  Alert,
  Snackbar,
  FormHelperText,
  Autocomplete,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import { TYPES } from "../constants";
import CustomButtonComponent from "./CustomButtonComponent";
import SchemeModalWrapper from "./SchemeModalWrapper";
import dayjs from "dayjs";
import RangePicker from "../components/RangePicker";
import api from "../axiosConfig";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import LoadingSpinner from "../components/LoadingSpinner";
import { DateObject } from "react-multi-date-picker";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { fetchEditPermissions } from "../api/editpermissions";

// icons
import AddIcon from "@mui/icons-material/Add";
import AddSchemeActual from "./AddSchemeActual";
import CreateScheme from "./CreateScheme";
import CreateActual from "./CreateActual";

const Scheme = ({ open }) => {
  const [colDefs] = useState(schemeColDef);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isActualModalOpen, setActualModalOpen] = useState(false);
  const [modalFormData, setModalFormData] = useState({
    schemeName: "",
    schemeStartDate: null,
    schemeEndDate: null,
    warehouse: [],
    channel: [],
    pricelist: [],
    productName: [],
    product: [],
    schemeType: "",
    mrpRate: "",
    rateImpact: "",
    quantityImpact: "",
    schemeImpactValue: "",
  });
  //   const [data, setData] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [warehouses, setWarehouses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [channels, setChannels] = useState([]);
  const [products, setProducts] = useState([]);
  const [openNotification, setNotification] = useState(false);
  const [openNotificationText, setNotificationText] = useState("");
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [pricelistOptions, setPricelistOptions] = useState([]);
  const [productNames, setProductNames] = useState([]);
  const [rowPriceList, setRowPriceList] = useState();
  const [isWarehouseDisabled, setIsWarehouseDisabled] = useState(false);
  const [isChannelDisabled, setIsChannelDisabled] = useState(false);
  const [isProductDisabled, setIsProductDisabled] = useState(false);
  const [isPriceListDisabled, setIsPriceListDisabled] = useState(false);
  const [isSchemeTypeDisabled, setIsSchemeTypeDisabled] = useState(false);

  const currentMonth = new Date();
  // const initialMonthRange = [currentMonth, currentMonth];
  const initialMonthRange = [new DateObject(), new DateObject()];

  const [rangeValue, setRangeValue] = useState(initialMonthRange);
  const { loading, data: rowData } = SchemeRowDef(rangeValue, setRangeValue);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [schemeModal, setSchemeModal] = useState(1);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalHeader, setModalHeader] = useState("Create Scheme");
  const [selectedPriceList, setSelectedPriceList] = useState("");
  const [selectedPriceListValue, setSelectedPriceListValue] = useState("");
  const [priceLists, setPriceLists] = useState([]);
  const [selectedProductCode, setSelectedProductCode] = useState([]);

  const {
    customOpenModal,
    setCustomOpenModal,
    mode,
    data,
    closeModal,
    openModalWithAScheme,
    editingValue,
    currency,
    hasActiveFilters,
    setHasActiveFilters,
  } = useModalContext();

  const user = getUser();
  const gridRef = useRef(null);

  //reset form
  const resetForm = () => {
    setModalFormData({
      schemeName: "",
      schemeStartDate: null,
      schemeEndDate: null,
      warehouse: [],
      channel: [],
      pricelist: [],
      productName: [],
      product: [],
      priceList: "",
      schemeType: "",
      rateImpact: "",
      mrpRate: "",
      quantityImpact: "",
      schemeImpactValue: "",
      costSpent: "",
    });
    setRowPriceList("");
    setErrors({}); // Reset errors as well
  };

  useEffect(() => {
    const fetchPermission = async () => {
      const permissions = await fetchEditPermissions();
      setIsButtonEnabled(permissions.Scheme === 1);
    };

    fetchPermission();
  }, []);
  //   api call

  //   Fetch dropdown options from API
  useEffect(() => {
    // Mock API fetch
    setWarehouseOptions(["Warehouse 1", "Warehouse 2", "Warehouse 3"]);
    setPricelistOptions(["Pricelist 1", "Pricelist 2", "Pricelist 3"]);
  }, []);

  useEffect(() => {
    // Fetch data from the backend
    api
      .get("/warehouses")
      .then((response) => setWarehouses(response.data || []))
      .catch((error) => console.error("Error fetching warehouses:", error));

    api
      .get("/channels")
      .then((response) => setChannels(response.data || []))
      .catch((error) => console.error("Error fetching channels:", error));

    api
      .get("/pricelist")
      .then((response) => setCategories(response.data || []))
      .catch((error) => console.error("Error fetching categories:", error));

    api
      .get("/productswithname")
      .then((response) => setProductNames(response.data || []))
      .catch((error) => console.error("Error fetching products:", error));
  }, []);

  const schemeTypeMapping = {
    OnInv: "On Invoice",
    OffInv: "Off Invoice",
    Visibility: "Visibility",
  };

  const handleRowClick = (event) => {
    const columnDef = event.column?.getColDef();

    // Prevent click event for "Actions" column
    if (columnDef?.field === "actions") {
      return;
    }

    const rowData = event.data;

    setRowPriceList(rowData.Pricelist); // Store raw pricelist first

    const selectedWarehouseOption = warehouses.find(
      (w) => w.Warehouse === rowData.Warehouse
    );
    const selectedChannelOption = channels.find(
      (c) => c.Channel === rowData.Channel
    );
    const selectedProductOption = productNames.find(
      (p) => p.Product_Name === rowData.Product_Name
    );

    setSelectedWarehouse(
      selectedWarehouseOption ? selectedWarehouseOption.Warehouse : ""
    );
    setSelectedChannel(
      selectedChannelOption ? selectedChannelOption.Channel : ""
    );
    setSelectedProduct(
      selectedProductOption ? selectedProductOption.Product_Name : ""
    );

    setModalFormData({
      schemeName: rowData.Scheme_Name || "",
      schemeStartDate: rowData.SchemeStartDate || "",
      schemeEndDate: rowData.SchemeEndDate || "",
      warehouse: rowData.Warehouse || "",
      channel: rowData.Channel || "",
      product: rowData.Product_Name || "",
      productCode: rowData.ProductCode || "",
      pricelist: rowData.Pricelist || "",
      schemeType: schemeTypeMapping[rowData.Scheme_Type] || "",
    });
    setIsWarehouseDisabled(true);
    setIsChannelDisabled(true);
    setIsProductDisabled(true);
    setIsPriceListDisabled(true);
    setIsSchemeTypeDisabled(true);

    // If Scheme Type is "OnInv", hit the API
    if (rowData.Scheme_Type === "OnInv") {
      const apiEndpoint = "/api/scheme/getoninv";
      // Prepare the body for the API call
      const requestBody = {
        schemeStartDate: rowData.SchemeStartDate,
        schemeEndDate: rowData.SchemeEndDate,
        warehouse: rowData.Warehouse,
        channel: rowData.Channel,
        pricelist: rowData.Pricelist,
        product: rowData.ProductCode,
        schemeType: "OnInv",
        page: "scheme",
        user: user,
        currencyType: currency,
      };

      api
        .post(apiEndpoint, { body: requestBody })
        .then((response) => {
          // Handle response here (e.g., update cost value in the state or form)

          const { Cost, Discount_Pricing_Impact } = response.data[0];

          setModalFormData((prevData) => ({
            ...prevData,
            costSpent: Cost, // Update costSpent field with API Cost value
            mrpRate: Discount_Pricing_Impact, // Update mrpRate field with Discount_Pricing_Impact value
          }));
        })
        .catch((error) => {
          console.error("Error fetching cost value:", error);
        });
    }

    // handleOpenModal();
    setModalHeader("Edit Actual");
    setActualModalOpen(true);
  };

  useEffect(() => {
    if (rowPriceList && priceLists.length > 0) {
      const selectedPriceListOption = priceLists.find(
        (p) => p.Pricelist?.trim() === rowPriceList?.trim()
      );

      setSelectedPriceList(selectedPriceListOption || null);
    }
  }, [rowPriceList, priceLists]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false); // Close the snackbar
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredWarehouses = warehouses.filter((warehouse) =>
    warehouse.Warehouse.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const filteredChannels = channels.filter((channel) =>
    channel.Channel.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const filteredCategory = categories.filter((category) =>
    category.Pricelist.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const filteredProduct = products.filter((product) => {
    const productCodeStr = product.ProductCode.toString(); // Convert ProductCode to string
    return productCodeStr.toLowerCase().includes(searchTerm.toLowerCase());
  });

  // Toaster Notification (Snackbar)
  useEffect(() => {
    if (openNotification) {
      const timer = setTimeout(() => {
        setNotification(false);
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [openNotification]);

  const mrpRate = [
    { MrpValue: "MRP", name: "MRP" },
    { MrpValue: "PTR", name: "PTR" },
  ];

  const toggleSchemeModal = () => {
    setSchemeModal((prevStatus) => (prevStatus === 1 ? 2 : 1));
  };

  const sideBar = {
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ],
    defaultToolPanel: "",
  };

  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;

  // date picker style

  const customTheme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-input": {
              fontSize: "14px", // Font size for the input field
            },
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            fontSize: "12px", // Font size for the calendar days
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontSize: "12px", // Font size for typography inside the Date Picker
          },
        },
      },
    },
  });

  const onGridReady = (params) => {
    gridRef.current = params.api;
  };

  // Update filter state whenever filters change.
  const onFilterChanged = (params) => {
    const currentFilters = params.api.getFilterModel();
    const isAnyFilterActive = Object.keys(currentFilters).length > 0;
    setHasActiveFilters(isAnyFilterActive);
  };

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner">
            <LoadingSpinner />
          </div>
        </div>
      )}
      <div
        className="ag-table-container"
        style={{ marginLeft: open ? "240px" : "0px" }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          {/* {loading && <LoadingSpinner />} */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",
              marginBottom: "20px",
            }}
          >
            <Box sx={{ display: "inline-flex" }}>
              <RangePicker
                rangeValue={rangeValue}
                setRangeValue={setRangeValue}
              />
            </Box>
            <div>
              <Button
                variant="contained"
                onClick={() => {
                  setModalOpen(true);
                  setIsSchemeTypeDisabled(false);
                }}
                disabled={!isButtonEnabled}
                style={{
                  fontSize: "12px",
                  flexGrow: 1,
                  marginLeft: "8px",
                  backgroundColor: !isButtonEnabled ? "#e0e0e0" : "#16a695",
                  color: !isButtonEnabled ? "#9e9e9e" : "#fff",
                  cursor: !isButtonEnabled ? "not-allowed" : "pointer",
                  padding: "8px",
                }}
                color="primary"
                size="small"
              >
                <AddIcon
                  sx={{
                    marginRight: "5px",
                  }}
                />
                Add New Scheme
              </Button>

              <Button
                variant="contained"
                onClick={() => {
                  // handleOpenModal("actual");
                  setActualModalOpen(true);
                  setModalHeader("Add new actual");
                  setActualModalOpen(true);
                  setIsWarehouseDisabled(false);
                  setIsChannelDisabled(false);
                  setIsProductDisabled(false);
                  setIsPriceListDisabled(false);
                  setIsSchemeTypeDisabled(false);
                }}
                disabled={!isButtonEnabled}
                style={{
                  fontSize: "12px",
                  flexGrow: 1,
                  marginLeft: "8px",
                  backgroundColor: !isButtonEnabled ? "#e0e0e0" : "#16a695",
                  color: !isButtonEnabled ? "#9e9e9e" : "#fff",
                  cursor: !isButtonEnabled ? "not-allowed" : "pointer",
                  padding: "8px",
                }}
                color="primary"
                size="small"
              >
                <AddIcon
                  sx={{
                    marginRight: "5px",
                  }}
                />
                Add New Actual
              </Button>
            </div>

            {/* Clear Filters Button */}
            <div
              style={{
                transition:
                  "opacity 0.4s ease-in-out, max-width 0.4s ease-in-out, margin 0.4s ease-in-out",
                opacity: hasActiveFilters ? 1 : 0,
                maxWidth: hasActiveFilters ? "150px" : "0px",
                overflow: "hidden",
                marginLeft: hasActiveFilters ? "10px" : "0px",
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  if (gridRef.current) {
                    gridRef.current.setFilterModel(null);
                    gridRef.current.onFilterChanged();
                  }
                }}
                style={{
                  fontSize: "12px",
                  color: "#000",
                  borderColor: "#707070",
                  whiteSpace: "nowrap",
                  padding: "8px",
                }}
                size="small"
              >
                Clear Filters
              </Button>
            </div>
          </div>
        </div>
        <div
          className="ag-theme-quartz"
          style={{
            width: "100%",
            height: "calc(100dvh - 190px)",
            fontSize: "12px",
          }}
        >
          <AgGridReact
            sideBar={sideBar}
            rowData={rowData}
            columnDefs={colDefs}
            pivotMode={false}
            //   onCellClicked={onCellClicked}
            onCellClicked={handleRowClick}
            frameworkComponents={{
              CustomButtonComponent,
            }}
            context={{ openModalWithAScheme }}
            onGridReady={onGridReady}
            onFilterChanged={onFilterChanged}
          />
        </div>
        <SchemeModalWrapper
          open={customOpenModal}
          setCustomOpenModal={setCustomOpenModal}
          mode={mode}
          handleClose={closeModal}
          data={editingValue}
        />
      </div>

      <CreateScheme
        open={isModalOpen}
        modalHeader={modalHeader}
        modalType={modalType}
        setModalOpen={setModalOpen}
        warehouses={warehouses}
        setWarehouses={setWarehouses}
        selectedWarehouse={selectedWarehouse}
        setSelectedWarehouse={setSelectedWarehouse}
        isWarehouseDisabled={isWarehouseDisabled}
        channels={channels}
        setChannels={setChannels}
        selectedChannel={selectedChannel}
        setSelectedChannel={setSelectedChannel}
        isChannelDisabled={isChannelDisabled}
        categories={categories}
        setCategories={setCategories}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        isPriceListDisabled={isPriceListDisabled}
        priceLists={priceLists}
        setPriceLists={setPriceLists}
        selectedPriceList={selectedPriceList}
        setSelectedPriceList={setSelectedPriceList}
        productNames={productNames}
        selectedProduct={selectedProduct}
        setSelectedProduct={setSelectedProduct}
        setSelectedProductCode={setSelectedProductCode}
        isProductDisabled={isProductDisabled}
        openNotification={openNotification}
        setNotification={setNotification}
        setNotificationText={setNotificationText}
        isSchemeTypeDisabled={isSchemeTypeDisabled}
        selectedPriceListValue={selectedPriceListValue}
        setSelectedPriceListValue={setSelectedPriceListValue}
        setSnackbarMessage={setSnackbarMessage}
        setSnackbarOpen={setSnackbarOpen}
        modalFormData={modalFormData}
        setModalFormData={setModalFormData}
        resetForm={resetForm}
        errors={errors}
        setErrors={setErrors}
      />

      <CreateActual
        open={isActualModalOpen}
        modalHeader={modalHeader}
        modalType={modalType}
        setActualModalOpen={setActualModalOpen}
        warehouses={warehouses}
        setWarehouses={setWarehouses}
        selectedWarehouse={selectedWarehouse}
        setSelectedWarehouse={setSelectedWarehouse}
        isWarehouseDisabled={isWarehouseDisabled}
        channels={channels}
        setChannels={setChannels}
        selectedChannel={selectedChannel}
        setSelectedChannel={setSelectedChannel}
        isChannelDisabled={isChannelDisabled}
        categories={categories}
        setCategories={setCategories}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        isPriceListDisabled={isPriceListDisabled}
        priceLists={priceLists}
        setPriceLists={setPriceLists}
        selectedPriceList={selectedPriceList}
        setSelectedPriceList={setSelectedPriceList}
        productNames={productNames}
        selectedProduct={selectedProduct}
        setSelectedProduct={setSelectedProduct}
        setSelectedProductCode={setSelectedProductCode}
        isProductDisabled={isProductDisabled}
        openNotification={openNotification}
        setNotification={setNotification}
        setNotificationText={setNotificationText}
        isSchemeTypeDisabled={isSchemeTypeDisabled}
        selectedPriceListValue={selectedPriceListValue}
        setSelectedPriceListValue={setSelectedPriceListValue}
        setSnackbarMessage={setSnackbarMessage}
        setSnackbarOpen={setSnackbarOpen}
        modalFormData={modalFormData}
        setModalFormData={setModalFormData}
        resetForm={resetForm}
        errors={errors}
        setErrors={setErrors}
        rowPriceList={rowPriceList}
      />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openNotification}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="warning"
          sx={{ width: "100%" }}
        >
          {openNotificationText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Scheme;
